<ng-content select="fui-icon"></ng-content>
